import { Dispatch } from 'redux'
import { getData } from '../utils/api'
import { SPEED_URLS, BZ_URLS, GEO_MAG_URLS, Option } from '../constants/urls'

export const RECEIVE_SPEED = 'RECEIVE_SPEED'
function receiveSpeed(data: any) {
  return {
    type: RECEIVE_SPEED,
    data: data,
  }
}

export const REQUEST_SPEED = 'REQUEST_SPEED'
function requestSpeed() {
  return {
    type: REQUEST_SPEED,
  }
}

export const ERROR_SPEED = 'ERROR_SPEED'
function errorSpeed(error: Error) {
  return {
    type: ERROR_SPEED,
    error: error,
  }
}

export function fetchSpeed(url: string) {
  return function (dispatch: Dispatch) {
    dispatch(requestSpeed())
    getData(url)
      .then((data) => {
        dispatch(receiveSpeed(data))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorSpeed(e))
      })
  }
}

export const RECEIVE_MAGNETOMETER = 'RECEIVE_MAGNETOMETER'
export function receiveMagnetometer(data: any, period: Option) {
  return {
    type: RECEIVE_MAGNETOMETER,
    data: data,
    period: period,
  }
}

export const REQUEST_MAGNETOMETER = 'REQUEST_MAGNETOMETER'
function requestMagnetometer() {
  return {
    type: REQUEST_MAGNETOMETER,
  }
}

export const ERROR_MAGNETOMETER = 'ERROR_MAGNETOMETER'
function errorMagnetometer(error: Error) {
  return {
    type: ERROR_MAGNETOMETER,
    error: error,
  }
}

export function fetchMagnetometer(urls: any, period: Option) {
  return function (dispatch: Dispatch) {
    dispatch(requestMagnetometer())

    const allDataPromises = Object.keys(urls).map((key) => {
      return getData(urls[key], { key: key })
    })

    Promise.all(allDataPromises)
      .then((data) => {
        dispatch(receiveMagnetometer(data, period))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorMagnetometer(e))
      })
  }
}

export const RECEIVE_BZ = 'RECEIVE_BZ'
function receiveBz(data: any) {
  return {
    type: RECEIVE_BZ,
    data: data,
  }
}

export const REQUEST_BZ = 'REQUEST_BZ'
function requestBz() {
  return {
    type: REQUEST_BZ,
  }
}

export const ERROR_BZ = 'ERROR_BZ'
function errorBz(error: Error) {
  return {
    type: ERROR_BZ,
    error: error,
  }
}

export const CREATE_ADJUSTED_BZ = 'CREATE_ADJUSTED_BZ'
export function createAdjustedBz(data: any, speedConversions: any) {
  return {
    type: CREATE_ADJUSTED_BZ,
    data: data,
    speedConversions: speedConversions,
  }
}

export function fetchBz(url: string) {
  return function (dispatch: Dispatch) {
    dispatch(requestBz())
    getData(url)
      .then((data) => {
        dispatch(receiveBz(data))
      })
      .catch((e) => {
        console.error(e)
        dispatch(errorBz(e))
      })
  }
}

export function update(period: Option) {
  return function (dispatch: Dispatch) {
    // @ts-ignore
    dispatch(fetchBz(BZ_URLS[period]))
    // @ts-ignore
    dispatch(fetchSpeed(SPEED_URLS[period]))
    // @ts-ignore
    dispatch(fetchMagnetometer(GEO_MAG_URLS, period))
  }
}

export const CHANGE_PERIOD = 'CHANGE_PERIOD'
export function changePeriod(period: Option) {
  return function (dispatch: Dispatch) {
    dispatch({
      type: CHANGE_PERIOD,
      period: period,
    })
    // @ts-ignore
    dispatch(update(period)) // ToDo: Is this actually sensible place for this
  }
}

export const CHANGE_MAGNETOMETER = 'CHANGE_MAGNETOMETER'
export function changeMagnetometer(magnetometer: any) {
  return {
    type: CHANGE_MAGNETOMETER,
    magnetometer: magnetometer,
  }
}
